import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { TextField } from './styles';

export const AgeField = styled(TextField)`
    ${breakpointUp.md`
        width: 84px;
    `}
`;
